import { extensionToMimeMap } from 'clean/utils/constants';

// Returns calculated values for given element with exact coordinates of it on screen,
// So you can attach anything next to it without worrying about context
export const calculateNodeOffset: (HTMLElement) => { x: number; y: number } = node => {
  const getOffset = (node, x, y) => {
    const offsetX = x + node.offsetLeft;
    const offsetY = y + node.offsetTop;

    if (node.offsetParent !== document.body) {
      return getOffset(node.offsetParent, offsetX, offsetY);
    }

    return { x: offsetX, y: offsetY };
  };

  const getScroll = (node, x, y) => {
    const scrollX = x + node.scrollLeft;
    const scrollY = y + node.scrollTop;

    if (node.parentNode !== document.body) {
      return getScroll(node.parentNode, scrollX, scrollY);
    }

    return { x: scrollX, y: scrollY };
  };

  const offsets = getOffset(node, 0, 0);

  const scrollOfsets = getScroll(node, 0, 0);

  return { x: offsets.x - scrollOfsets.x, y: offsets.y - scrollOfsets.y };
};

// Exports random string, good for temp ids
export const randString: () => string = () => {
  return Math.random().toString(36).substr(2, 9);
};

// Converts file name into mime type
export const convertFileNameToMime: (arg: string) => string = fileName => {
  const extension = fileName.slice(fileName.lastIndexOf('.'));

  return extensionToMimeMap[extension] || 'application/none';
};
